/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ count: NonNullable<unknown> }} Notifications_Nav_BadgeInputs */

const en_notifications_nav_badge = /** @type {(inputs: Notifications_Nav_BadgeInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} unread`)
};

const pl_notifications_nav_badge = /** @type {(inputs: Notifications_Nav_BadgeInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Nieprzeczytane: ${i?.count}`)
};

/**
* | output |
* | --- |
* | "{count} unread" |
*
* @param {Notifications_Nav_BadgeInputs} inputs
* @param {{ locale?: "en" | "pl" }} options
* @returns {LocalizedString}
*/
export const notifications_nav_badge = /** @type {((inputs: Notifications_Nav_BadgeInputs, options?: { locale?: "en" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Notifications_Nav_BadgeInputs, { locale?: "en" | "pl" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pl") return pl_notifications_nav_badge(inputs)
	return en_notifications_nav_badge(inputs)
});